import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function ManageTicketMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
    ${sidebarHelper.checkOpenItem(openItem, "manage-tickets")} `}
    >
      <Link
        to="# "
        className={`nav-link  
      ${sidebarHelper.checkActiveItem(openItem, "manage-tickets")} `}
      >
        <i className="nav-icon fa fa-ticket-alt "></i>
        <p>
          مدیریت تیکت ها
          <i className="right fa fa-angle-left"></i>
        </p>
      </Link>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/ticket/all"
            className={`nav-link  
      ${sidebarHelper.checkActiveItem(activeItem, "all-tickets")} `}
          >
            <i className="fa fa-list  nav-icon"></i>
            <p>همه تیکت ها</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/ticket/category-ticket"
            className={`nav-link  
  ${sidebarHelper.checkActiveItem(activeItem, "all-category-ticket")} `}
          >
            <i className="fa  fa-list nav-icon"></i>
            <p>دسته های تیکت</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/ticket/all-notification"
            className={`nav-link  
    ${sidebarHelper.checkActiveItem(activeItem, "all-notification-ticket")} `}
          >
            <i className="fa fa-bell nav-icon"></i>
            <p>اطلاع رسانی تیکت</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}

export default ManageTicketMenu;
